<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-4">
        <div class="card rounded-3">
          <div class="d-flex py-3 px-4 justify-content-between">
            <div>
              <p class="fs-6 m-0 p-0 text-uppercase">perangkat aktif</p>
              <h5 class="fs-3 m-0 p-0">{{ perangkatAktif }}</h5>
            </div>
            <div class="mt-2">
              <div class="bg-danger position-relative rounded-circle" style="width: 50px; height: 50px;">
                <div class="position-absolute start-50 translate-middle" style="top:45%">
                  <img :src="logoWhite" style="width: 20px;">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="card rounded-3">
          <div class="d-flex py-3 px-4 justify-content-between">
            <div>
              <p class="fs-6 m-0 p-0 text-uppercase">perangkat kominfo</p>
              <h5 class="fs-3 m-0 p-0">{{ kominfoAktif }}</h5>
            </div>
            <div class="mt-2">
              <div class="bg-primary position-relative rounded-circle" style="width: 50px; height: 50px;">
                <div class="position-absolute start-50 translate-middle" style="top:45%">
                  <img :src="logoWhite" style="width: 20px;">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="card rounded-3">
          <div class="d-flex py-3 px-4 justify-content-between">
            <div>
              <p class="fs-6 m-0 p-0 text-uppercase">pelanggan</p>
              <h5 class="fs-3 m-0 p-0">{{ totalPelanggan }}</h5>
            </div>
            <div class="mt-2">
              <div class="bg-success position-relative rounded-circle" style="width: 50px; height: 50px;">
                <div class="position-absolute top-50 start-50 translate-middle">
                  <i class="fa fa-users text-white" style="width: 20px;"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pl-2 pt-4">
        <div class="mb-4">
          <Chart />
        </div>
        <div class="mb-4">
          <Chart2 />
        </div>
        <div>
          <TableDash />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import logoWhite from "../assets/img/shapes/perangkatsvg.svg";
import Chart from "./components/dashboard/Chart1.vue";
import Chart2 from "./components/dashboard/Chart2.vue";
import TableDash from "./components/dashboard/TableDashboard.vue";
import {ApiService} from "../axios/apiService";
import store from "../store";

const apiService = new ApiService();
const perangkatAktif = ref('');
const kominfoAktif = ref('');
const totalPelanggan = ref('');

onMounted(async()=>{
  const resPerangkat = await apiService.perangkatAktif();
  perangkatAktif.value = resPerangkat.data;
  const resKominfo = await apiService.totalPerangkatKominfo();
  kominfoAktif.value = resKominfo.data;
  const totalPelanggan_ = await apiService.getPelanggan(100000,0);
  totalPelanggan.value = totalPelanggan_.data.content.length;
  store.state.showNavbar = true;;
  store.state.showSidenav = true;
  store.state.showFooter = true;
});
</script>
